// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"663":"367ec7d1","716":"718f290c"}[chunkId] + ".chunk.css";
};